import { render } from "./ChoiceOfPractice.vue?vue&type=template&id=e61bb7ea"
import script from "./ChoiceOfPractice.vue?vue&type=script&lang=js"
export * from "./ChoiceOfPractice.vue?vue&type=script&lang=js"

import "./ChoiceOfPractice.vue?vue&type=style&index=0&id=e61bb7ea&lang=scss"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__